import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '😰',
    title: 'pages.quizOnboarding.nervousness.answer1',
    value: 'yes',
  },
  {
    emoji: '😅',
    title: 'pages.quizOnboarding.nervousness.answer2',
    value: 'sometimes',
  },
  {
    emoji: '😎',
    title: 'pages.quizOnboarding.nervousness.answer3',
    value: 'not_really',
  },
]

export default function NervousnessPage() {
  const language = useSelectedLanguageName()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const selected = event.currentTarget.value as string
    if (selected) localStorage.setItem('quizNervousness', selected)
  }

  return (
    <QuizChoicePage
      answers={answers}
      onSubmit={handleSubmit}
      title="pages.quizOnboarding.nervousness.title"
      translationInterpolation={{ language }}
    />
  )
}
